interface MedicationAndDateHeaderProps {
  medicationName?: string;
  scheduleDate?: string;
  type: string;
}

export class MedicationAndDateHeaderParams {
  static medicationAndDateHeaderProps: MedicationAndDateHeaderProps;
}